// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.amenities.units.RentalManagerUserPropertyUnitAmenityV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create,
  RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyUnitAmenityCreateResponseV2WebDto,
  UserPropertyUnitAmenityCreateV2RequestDto,
  UserPropertyUnitAmenityDeleteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Args {
  postData: UserPropertyUnitAmenityCreateV2RequestDto;
}

export type RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Options = UseMutationOptions<
  UserPropertyUnitAmenityCreateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Args
>;

/**
 * Create a free text unit amenity
 */
export const useRentalManagerUserPropertyUnitAmenityV2WebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Args) =>
      RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Args {
  postData: UserPropertyUnitAmenityDeleteV2RequestDto;
}

export type RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Args
>;

/**
 * Delete a free text unit amenity
 */
export const useRentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete(args.postData, httpClient),
  });
};
